const devLog = (...args) => {
    if (process.env.REACT_APP_ENV === 'development') {
        console.log(...args);
    }
};

const stagingLog = (...args) => {
    if (process.env.REACT_APP_ENV === 'staging') {
        console.log(...args);
    }
};

const prodLog = (...args) => {
    if (process.env.REACT_APP_ENV === 'production') {
        console.log(...args);
    }
};

export { devLog, stagingLog, prodLog };